//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Badge",
  props: {
    type: {
      type: String,
      default: "primary"
    }
  }
});